import * as React from 'react';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

function NotFoundPage(props) {
    return (
      <Typography variant="body2" color="text.secondary" align="center" {...props}>
        Oooops!
      </Typography>
    );
  }

  export default NotFoundPage;